<template>
  <div class="tw:flex tw:w-full tw:justify-between tw:items-center tw:bg-gray-100 tw:h-[72px] tw:px-6 tw:rounded-t-xl">
    <template v-for="(step, index) in steps" :key="step.number">
      <div class="tw:flex tw:items-center tw:gap-x-2">
        <span
          class="tw:shadow-sm tw:flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:rounded-full tw:font-bold tw:text-sm"
          :class="step.isActive || step.isCompleted ? 'tw:bg-blue-700 tw:text-white' : 'tw:bg-white tw:text-gray-600'"
        >
          <CheckMark class="tw:fill-white tw:w-[10px]" v-if="step.isCompleted" />
          <span v-else>{{ step.number }}</span>
        </span>

        <p
          class="tw:text-xs tw:whitespace-nowrap"
          :class="step.isActive ? 'tw:flex tw:text-blue-700 tw:font-bold' : 'tw:hidden tw:md:flex tw:text-gray-600'"
        >
          {{ $t(step.label) }}
        </p>
      </div>

      <div v-if="index < steps.length - 1" class="tw:flex-1 tw:h-[1px] tw:mx-4 tw:bg-gray-300" />
    </template>
  </div>
</template>
<script setup>
import CheckMark from '@/components/icons/CheckMark.svg?component'

defineProps({
  steps: Array,
})
</script>
